<template>
    <div class="okraina-retail-selected">

        <!-- Загрузка -->
        <template v-if="loading">
            <div class="text-center">
                <okraina-loader-inline />
            </div>
        </template>

        <template v-else>

            <div class="address" @click="onAddressClick">
                <div>
                    <template v-if="shop">
                        {{ shop.PROPS.ADDRESS }}
                    </template>
                    <template v-else>
                        Извините, данный магазин отключен, выберите другой магазин.
                    </template>
                </div>
                <div>
                    <span class="fi fi-pencil icon"></span>
                </div>
            </div>

            <div class="phone" v-if="shop && shop.PROPS.PHONE">
                Узнать наличие ассортимена и сделать заказ в этом магазине можно по телефону
                <a :href="'tel:' + shop.PROPS.PHONE">{{ shop.PROPS.PHONE }}</a>
            </div>

            <div class="schedule" v-if="shop">

                <div>
                    <div class="clock">
                        <div>
                            <span class="fi fi-time-outline icon"></span>
                        </div>
                        <div>
                            Часы работы <br />
                            магазина:
                        </div>

                    </div>
                </div>
                <div class="delimiter">
                </div>
                <div class="value">
                    {{ shop.PROPS.WORKTIME }}
                </div>

            </div>

        </template>


    </div>
</template>

<script>
import okrainaLoaderInline from "@/components/loader.inline.vue"

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";

import { mapGetters } from "vuex";

export default {
    name: "okraina-retail-selected",
    components: {
        okrainaLoaderInline
    },
    data() {
        return {
            loading: false,
            shop: false
        }
    },

    computed: {

        ...mapGetters({
            retailShopId: "retail/getShopId"
        }),
    },

    methods: {

        loadData() {

            this.loading = true;

            rest
                .call("company.shops", {
                    method: "post",
                    data: {
                        SELECT: ["ID", "NAME"],
                        FILTER: {
                            "!PROPERTY_AVAILABLE_IN_APP": false,
                            "ID": this.retailShopId
                        },
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {
                        if (data.ITEMS.length > 0) {
                            this.shop = data.ITEMS[0];
                        }

                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        /**
         * Клик по адресу
         */
        onAddressClick() {
            //сброс выбранного магазина
            this.$store.dispatch("retail/setRetailShopId", 0);
        }

    },

    created() {
        this.loadData();
    },

}

</script>

<style lang="scss">
.okraina-retail-selected {
    .address {
        display: grid;
        grid-template-columns: 1fr auto;
        padding: 15px 15px 15px 20px;
        align-items: center;
        gap: 10px;

        color: var(--color-color1);
        font-size: 12px;
        font-weight: 600;

        border-radius: 10px;
        background: var(--color-color9);
        margin-bottom: 13px;
        cursor: pointer;

        .icon {
            font-size: 21px;
        }
    }

    .schedule {
        display: flex;

        padding: 20px;
        flex-wrap: wrap;
        gap: 10px;
        column-gap: 20px;

        border-radius: 10px;
        background: var(--color-block-background);
        margin-bottom: 20px;

        >div {
            display: flex;
            align-items: center;
        }

        .clock {
            display: flex;
            column-gap: 10px;
            align-items: center;

            color: var(--color-color10);
            font-size: 14px;
            font-weight: 500;

            .icon {
                font-size: 22px;
            }
        }

        .delimiter {
            width: 1px;
            background-color: var(--color-color7);
        }

        .value {
            flex: 1;
            color: var(--color-text-dark);
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
        }
    }

    .phone {
        padding: 20px;
        border-radius: 10px;
        background: var(--color-block-background);
        margin-bottom: 13px;
        font-size: 12px;
    }




}
</style>